module.exports = __webpack_public_path__ + "img/snow_love.de6bb632.jpg";